import jQuery from "jquery";

// eslint-disable-next-line no-undef
const $ = jQuery;

function isEmail(email) {
    // eslint-disable-next-line no-useless-escape
    const regex =
        /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

$(document).ready(() => {
    // eslint-disable-next-line consistent-return
    $(".contact-form").submit(() => {
        $(".contact-form .fields").removeClass("error");
        $(".contact-form small").hide();
        let submit = true;

        // eslint-disable-next-line eqeqeq
        if ($("#ContactFormName").val().length == 0) {
            $("#ContactFormName").addClass("error");
            $("#ContactFormName").siblings("small").show();
            submit = false;
        }
        // eslint-disable-next-line eqeqeq
        if ($("#ContactFormPhone").val().length == 0) {
            $("#ContactFormPhone").addClass("error");
            $("#ContactFormPhone").siblings("small").show();
            submit = false;
        }
        // eslint-disable-next-line eqeqeq
        if (
            !isEmail($("#ContactFormEmail").val()) ||
            $("#ContactFormEmail").val().length == 0
        ) {
            $("#ContactFormEmail").addClass("error");
            $("#ContactFormEmail").siblings("small").show();
            submit = false;
        }
        // eslint-disable-next-line eqeqeq
        if ($("#ContactFormMessage").val().length == 0) {
            $("#ContactFormMessage").addClass("error");
            $("#ContactFormMessage").siblings("small").show();
            submit = false;
        }
        if (!submit) return false;
    });
});
